export default "__VITE_PUBLIC_ASSET__e0718df2__"